import React from 'react'
import '../styles/Error.css'

function Error() {
    return (
        <div className='error'>
            <h1>404 Page not found!</h1>
            <div className="error-img"></div>
        </div>
    )
}

export default Error